export default function ListingPublishForm({
  type,
  values,
  errors,
  marketplaceToday,
  onFieldChange,
  onSubmit,
}) {
  const isTrip = type === "trip";
  const prefix = isTrip ? "trip" : "errand";

  function update(field, event) {
    onFieldChange(field, event.target.value);
  }

  function fieldError(field) {
    const error = errors[field];
    if (!error) return null;
    return (
      <span className="field-error" id={`${prefix}-${field}-error`} role="alert">
        {error}
      </span>
    );
  }

  return isTrip ? (
    <form className="form" noValidate onSubmit={onSubmit}>
      <label>
        Origin
        <input
          name="origin"
          required
          aria-invalid={Boolean(errors.origin)}
          aria-describedby={errors.origin ? "trip-origin-error" : undefined}
          value={values.origin}
          onChange={(event) => update("origin", event)}
        />
        {fieldError("origin")}
      </label>
      <label>
        Destination
        <input
          name="destination"
          required
          aria-invalid={Boolean(errors.destination)}
          aria-describedby={
            errors.destination ? "trip-destination-error" : undefined
          }
          value={values.destination}
          onChange={(event) => update("destination", event)}
        />
        {fieldError("destination")}
      </label>
      <label>
        Travel date
        <input
          name="date"
          type="date"
          min={marketplaceToday}
          required
          aria-invalid={Boolean(errors.date)}
          aria-describedby={errors.date ? "trip-date-error" : undefined}
          value={values.date}
          onChange={(event) => update("date", event)}
        />
        {fieldError("date")}
      </label>
      <label>
        Slots
        <input
          name="slots"
          type="number"
          min="1"
          step="1"
          required
          aria-invalid={Boolean(errors.slots)}
          aria-describedby={errors.slots ? "trip-slots-error" : undefined}
          value={values.slots}
          onChange={(event) => update("slots", event)}
        />
        {fieldError("slots")}
      </label>
      <label>
        Trip service fee (PHP)
        <input
          name="fee"
          type="number"
          min="0"
          step="0.01"
          required
          aria-invalid={Boolean(errors.fee)}
          aria-describedby={errors.fee ? "trip-fee-error" : undefined}
          value={values.fee}
          onChange={(event) => update("fee", event)}
        />
        {fieldError("fee")}
      </label>
      <label>
        Items, comma separated
        <input
          name="tags"
          value={values.tags}
          placeholder="Any particular item or any item"
          onChange={(event) => update("tags", event)}
        />
      </label>
      <label>
        Trip description (optional)
        <textarea
          name="description"
          rows="4"
          maxLength={2000}
          aria-describedby="trip-description-help"
          value={values.description}
          onChange={(event) => update("description", event)}
          placeholder="Share order item recommendations, possible routes, side trips, timing, or other helpful details."
        />
        <span className="field-hint" id="trip-description-help">
          Up to 2,000 characters. Avoid sharing private contact details.
        </span>
      </label>
      <button type="submit">Publish trip</button>
    </form>
  ) : (
    <form className="form" noValidate onSubmit={onSubmit}>
      <p>
        Share only a public neighborhood/area and store. Never enter a home
        address.
      </p>
      <label>
        Local area
        <input
          name="area"
          required
          maxLength="120"
          aria-invalid={Boolean(errors.area)}
          aria-describedby={errors.area ? "errand-area-error" : undefined}
          value={values.area}
          onChange={(event) => update("area", event)}
          placeholder="Example: BF Homes, Paranaque"
        />
        {fieldError("area")}
      </label>
      <label>
        Store
        <input
          name="store"
          required
          maxLength="120"
          aria-invalid={Boolean(errors.store)}
          aria-describedby={errors.store ? "errand-store-error" : undefined}
          value={values.store}
          onChange={(event) => update("store", event)}
          placeholder="Example: SM Supermarket"
        />
        {fieldError("store")}
      </label>
      <label>
        Errand description (optional)
        <textarea
          name="description"
          rows="4"
          maxLength={2000}
          aria-describedby="errand-description-help"
          value={values.description}
          onChange={(event) => update("description", event)}
          placeholder="Share order item recommendations, possible side trips, route, timing, or other helpful details."
        />
        <span className="field-hint" id="errand-description-help">
          Up to 2,000 characters. Avoid sharing private contact details.
        </span>
      </label>
      <label>
        Planned date
        <input
          name="date"
          type="date"
          min={marketplaceToday}
          required
          aria-invalid={Boolean(errors.date)}
          aria-describedby={errors.date ? "errand-date-error" : undefined}
          value={values.date}
          onChange={(event) => update("date", event)}
        />
        {fieldError("date")}
      </label>
      <label>
        Runner fee (PHP)
        <input
          name="fee"
          type="number"
          min="0"
          step="0.01"
          required
          aria-invalid={Boolean(errors.fee)}
          aria-describedby={errors.fee ? "errand-fee-error" : undefined}
          value={values.fee}
          onChange={(event) => update("fee", event)}
        />
        {fieldError("fee")}
      </label>
      <label>
        Request slots
        <input
          name="slots"
          type="number"
          min="1"
          step="1"
          required
          value={values.slots}
          onChange={(event) => update("slots", event)}
        />
      </label>
      <p>
        Each non-cancelled request uses one slot. Cancelling a request frees its
        slot.
      </p>
      <button type="submit">Publish offer</button>
    </form>
  );
}
